export enum ContentStatus {
  INCOMPLETE = 'incomplete',
  PREPARING = 'preparing',
  COMPLETE = 'complete',
}